import {
  reset,
  SubmissionError,
} from 'redux-form';

import request from '@utils/request';

import {
  hideLoadingModal,
  showLoadingModal,
} from '@actions/loadingModal';

import { openSnackBar } from '@actions/snackBar';

const PREFIX = '[CONTACT]';

export const GET_CONTACT_DETAILS_REQUEST = `${PREFIX} GET_CONTACT_DETAILS_REQUEST`;
export const GET_CONTACT_DETAILS_SUCCESS = `${PREFIX} GET_CONTACT_DETAILS_SUCCESS`;
export const GET_CONTACT_DETAILS_FAILURE = `${PREFIX} GET_CONTACT_DETAILS_FAILURE`;

const getContactDetailsRequest = () => ({
  type: GET_CONTACT_DETAILS_REQUEST,
});

const getContactDetailsSuccess = payload => ({
  type: GET_CONTACT_DETAILS_SUCCESS,
  payload,
});

const getContactDetailsFailure = () => ({
  type: GET_CONTACT_DETAILS_FAILURE,
});

export const getContactDetails = () => (dispatch) => {
  dispatch(getContactDetailsRequest());
  showLoadingModal(dispatch);

  return request
    .get('v1/contact/')
    .then(({ data }) => dispatch(getContactDetailsSuccess(data)))
    .catch((error) => {
      dispatch(getContactDetailsFailure());

      throw error;
    })
    .finally(() => hideLoadingModal(dispatch));
};

export const POST_CONTACT_FORM_REQUEST = `${PREFIX} POST_CONTACT_FORM_REQUEST`;
export const POST_CONTACT_FORM_SUCCESS = `${PREFIX} POST_CONTACT_FORM_SUCCESS`;
export const POST_CONTACT_FORM_FAILURE = `${PREFIX} POST_CONTACT_FORM_FAILURE`;

const postContactFormRequest = () => ({
  type: POST_CONTACT_FORM_REQUEST,
});

const postContactFormSuccess = payload => ({
  type: POST_CONTACT_FORM_SUCCESS,
  payload,
});

const postContactFormFailure = () => ({
  type: POST_CONTACT_FORM_FAILURE,
});

export const sendContactFormData = payload => (dispatch) => {
  dispatch(postContactFormRequest());

  return request
    .post('v1/contact/', payload)
    .then(() => {
      dispatch(postContactFormSuccess());
      dispatch(reset('contact'));
      dispatch(openSnackBar('Your contact form has been submitted. Thank you.'));
    })
    .catch(({ response: { data } = {} }) => {
      dispatch(postContactFormFailure());
      dispatch(openSnackBar('Something went wrong.', true));

      throw new SubmissionError(data);
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/contact.js